const BASE_URL = "https://wordpress.yanisallali.com/wp-json/wp/v2";
const CONTACT_URL = "https://api.yanisallali.com/api";
const themeColors = {
    "magenta":"#763FDE",
    "white":"#FFFFFF",
    "black":"#131313"
}

export {BASE_URL, themeColors, CONTACT_URL};